// Filter configuration for data export form
// This file defines which filter fields are available for each resource type
// when creating data exports.

import {
    agentFilterFields,
    contactFilterFields,
    conversationFilterFields,
    knowledgeBaseFilterFields,
    transactionFilterFields
} from '../Shared/Filters/filterConfig';
import { Resource } from '../../Constants/socket';

// Mapping of resources to their available filter fields
export const resourceFilterMapping = {
    [Resource.AGENT]: agentFilterFields,
    [Resource.CONTACT]: contactFilterFields,
    [Resource.CONVERSATION]: conversationFilterFields,
    [Resource.KNOWLEDGE_BASE]: knowledgeBaseFilterFields,
    [Resource.MESSAGE]: [], // Messages inherit only global filters
    [Resource.TRANSACTION]: transactionFilterFields
};

// Shared filter that applies to all resources
// This filter will be automatically injected into each resource's filters
export const sharedExportFilters = [
    {
        key: 'created_at',
        labelKey: 'filters_field_created_at',
        type: 'dateRange',
        startKey: 'created_at_start',
        endKey: 'created_at_end',
    }
];
